export interface IAnnouncementEvents {
  UPDATE: string;
  SET_ACTIVE_ITEM: string;
  SELECT_ANNOUNCEMENT: string;
  ANNOUNCEMENTS_LOADED: string;
}

export const ANNOUNCEMENTS_EVENTS: IAnnouncementEvents = {
  UPDATE: 'ANNOUNCEMENTS.UPDATE',
  SET_ACTIVE_ITEM: 'ANNOUNCEMENTS.SET_ACTIVE_ITEM',
  SELECT_ANNOUNCEMENT: 'ANNOUNCEMENTS.SELECT_ANNOUNCEMENT',
  ANNOUNCEMENTS_LOADED: 'ANNOUNCEMENTS.ANNOUNCEMENTS_LOADED',
};
